import React, { Component } from 'react';
import { connect } from 'react-redux'
import { updateDashboardSearch, updateDashboardTable } from '../reducers';
import axios from '~/axios';
import { Modal, Spin, Input } from 'antd';
import debounce from 'lodash.debounce';

const { Search } = Input;

import DashboardSubmissions from '../components/dashboard/DashboardSubmissions';
import NotificationModal from '../components/dashboard/NotificationModal';

class Dashboard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            submissions: [],
            total: 0,
            showSendDialog: false,
            showSendDialogSpinner: false,
            loading: false
        }
        this.showSendDialog = this.showSendDialog.bind(this);
        this.closeSendDialog = this.closeSendDialog.bind(this);
        this.sendNotification = this.sendNotification.bind(this);
        this.handleRegister = this.handleRegister.bind(this);
        this.handleUnregister = this.handleUnregister.bind(this);
        this.handleRemoveSubmission = this.handleRemoveSubmission.bind(this);

        this.updateDashboardSearch = this.props.updateDashboardSearch.bind(this);
        this.updateDashboardSearchDebounced = debounce(this.updateDashboardSearch, 200)
    }


    /**
     * Retrieves all submissions currently in the database.
     */
    componentDidMount() {
        this.getDashboardPage();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.dashboardPage !== this.props.dashboardPage) {
            this.getDashboardPage();
        } else if (prevProps.dashboardSearch !== this.props.dashboardSearch || prevProps.dashboardSorter !== this.props.dashboardSorter) {
            if (this.props.dashboardPage !== 1) this.props.updateDashboardTable(1, {}, this.props.dashboardSorter);
            else this.getDashboardPage(true);
        }
    }

    getDashboardPage(resetPage = false) {
        let page = resetPage ? 1 : this.props.dashboardPage;
        let search = this.props.dashboardSearch;

        let orderDir = (() => {
            if (this.props.dashboardSorter) {
                if (this.props.dashboardSorter.order === 'ascend') return 'asc';
                else if (this.props.dashboardSorter.order === 'descend') return 'desc';
            }
            return null;
        })()
        let orderBy = orderDir ? this.props.dashboardSorter?.field : null;

        console.log("get dashboard page from main hasboard compoennt")
        this.setState({ loading: true });
        axios.get('/api/submissions', {
            params: {
                page: page,
                search: search,
                orderBy: orderBy,
                orderDir: orderDir,
            }
        }).then(({ data }) => {
            this.setState({ loading: false, submissions: data.data, total: data.meta.total });
        });
    }

    showSendDialog(email, submissionID, type) {
        // show the 'send notification' confirmation
        this.setState({ email: email, submissionID: submissionID, showSendDialog: type });
    }

    closeSendDialog() {
        // close the 'send notification' confirmation
        this.setState({ email: null, submissionID: null, showSendDialog: false });
    }


    /**
     * Updates the state when a submission is registered on LearningHub.
     * @param {number} submissionID - The ID of the submission to update.
     */
    handleRegister(submissionID) {
        console.log('registering entry from parent');
        let submissions = [...this.state.submissions];
        let index = submissions.findIndex(object => {
            return object.submissionID == submissionID;
        });
        submissions[index].registered = true;
        console.log(submissions);
        this.setState({ submissions: submissions });
    }

    /**
     * Updates the state when a submission is registration is undone back to false.
     * @param {number} submissionID - The ID of the submission to update.
     */
    handleUnregister(submissionID) {
        console.log('unregistering entry from parent');
        let submissions = [...this.state.submissions];
        let index = submissions.findIndex(object => {
            return object.submissionID == submissionID;
        });
        submissions[index].registered = false;
        this.setState({ submissions: submissions });
    }

    /**
     * Removes a specific submissions from this component's state.
     * @param {number} - The ID of the submissions to remove.
     */
    handleRemoveSubmission(submissionID) {
        console.log('removing submission from main dashboard component')
        let submissions = [...this.state.submissions];
        let index = submissions.findIndex(element => {
            return element.submissionID === submissionID;
        });
        submissions.splice(index, 1);
        this.setState({ submissions: submissions });
        this.getDashboardPage();
    }

    async sendNotification(type) {
        console.log(this.state.submissions);

        this.setState({ showSendDialogSpinner: true });
        // attempt to send the email using provided data
        await axios.post('/api/notification', {
            'to': this.state.email,
            'submissionID': this.state.submissionID,
            'type': type,
        }).then((response) => {
            if (response.status == 200) {
                // if the email sent, update the state/view
                let submissions = [...this.state.submissions];
                let index = submissions.findIndex((object) => {
                    return object.submissionID == this.state.submissionID;
                });
                submissions[index].notified = true;
                this.setState({ submissions: submissions });
            }
        }).catch((error) => {
            Modal.error({
                title: 'Something Went Wrong',
                content: 'The email could not be sent. Is the email a valid email address?'
            });
        });
        this.setState({ showSendDialogSpinner: false });
        this.closeSendDialog();
    }

    render() {
        return (
            <div className="container">
                <NotificationModal showSendDialog={ this.state.showSendDialog }
                                   onOk={ () => this.sendNotification(this.state.showSendDialog) }
                                   onCancel={ this.closeSendDialog } spinning={ this.state.showSendDialogSpinner }/>
                <h1>Dashboard</h1>
                <Search
                    allowClear
                    placeholder="Search Employee Name"
                    onChange={ event => this.updateDashboardSearchDebounced(event.target.value) }
                    enterButton
                    defaultValue={ this.props.dashboardSearch }
                    style={ { width: 250, marginBottom: '1em' } }
                />
                <DashboardSubmissions loading={ this.state.loading } data={ this.state.submissions }
                                      total={ this.state.total } showSendDialog={ this.showSendDialog }
                                      handleRegister={ this.handleRegister } handleUnregister={ this.handleUnregister }
                                      handleRemoveSubmission={ this.handleRemoveSubmission }/>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return state;
}

// connect the login form to redux
export default connect(mapStateToProps, { updateDashboardSearch, updateDashboardTable })(Dashboard);